import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { admin } from '@repletoryreach/sdk-api';

/** The marketing site's news and updates, drafts included. */
export function useBlogPosts() {
  return useQuery({ queryKey: ['admin', 'blog', 'posts'], queryFn: () => admin.listBlogPosts() });
}

export function useBlogAssets() {
  return useQuery({ queryKey: ['admin', 'blog', 'assets'], queryFn: () => admin.listBlogAssets() });
}

function useInvalidatePosts() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['admin', 'blog', 'posts'] });
}

export function useCreateBlogPost() {
  const invalidate = useInvalidatePosts();
  return useMutation({ mutationFn: (req: admin.UpsertBlogPostRequest) => admin.createBlogPost(req), onSuccess: invalidate });
}

export function useUpdateBlogPost() {
  const invalidate = useInvalidatePosts();
  return useMutation({ mutationFn: ({ id, ...req }: { id: string } & admin.UpsertBlogPostRequest) => admin.updateBlogPost(id, req), onSuccess: invalidate });
}

export function usePublishBlogPost() {
  const invalidate = useInvalidatePosts();
  return useMutation({ mutationFn: ({ id, publish }: { id: string; publish: boolean }) => (publish ? admin.publishBlogPost(id) : admin.unpublishBlogPost(id)), onSuccess: invalidate });
}

export function useDeleteBlogPost() {
  const invalidate = useInvalidatePosts();
  return useMutation({ mutationFn: (id: string) => admin.deleteBlogPost(id), onSuccess: invalidate });
}

export function useUploadBlogAsset() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (file: File) => admin.uploadBlogAsset(file), onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'blog', 'assets'] }) });
}
